import React from 'react';
import classNames from 'classnames';
import styles from './css/index.module.scss';
import ArrowIcon from '../../../../assets/icons/arrowRightWhite.svg';
import useTranslations from '../../../../hooks/useTranslations';
import { DICTIONARY } from '../../../../translations/dictionary';

function BackButton({ onClick }) {
  const { t } = useTranslations();

  return (
    <button type="button" className={classNames(styles.button, 'noSelection')} onClick={onClick}>
      <img src={ArrowIcon} alt="<" className={styles.icon} />
      <p className={styles.text}>{t(DICTIONARY.back)}</p>
    </button>
  );
}

export default BackButton;
